// extracted by mini-css-extract-plugin
export var markdown = "_sl-0";
export var tableWrapper = "_sl-1";